var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-6"},[_c('vue-element-loading',{attrs:{"active":_vm.show,"spinner":"ring","is-full-screen":"","color":"#38b2ac"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }